module.exports = __webpack_public_path__ + "static/media/privacy.05de098a.svg";